import React, { Component } from 'react';
import {Header} from './header.js';
import {Footer} from './footer.js';
import './product-list.css';
import * as util from './util.js';
import { defaultHeaders } from './util';
import service from './resource/service.png';
import softwareforschung from './resource/softwareforschung.png';
import tender from './resource/tender.png';
import doc from './resource/doc.png';
import gb from './resource/gb.png';
import software from './resource/software.png';
import hardware from './resource/hardware.png';


let faqProductList = [
  {
    content: "Nur einige Beispiele: <ul><li>Software-Module im Bereich Ihres KIS </li><li>Erweiterungen  Ihres Zentralsystems  mit weiteren Funktionen </li><li>Im System  vorher nicht  vorhandene  Auswertungen,  die Sie oder die für  Sie geschrieben wurden </li><li>Datenschutz-Regelungen und -Umsetzungspapiere </li><li>Vorlagen</li><li>erfolgreiche  oder erfolglose  Anträge (z.B. Großgeräte-Anträge) <Leistungsverzeichnisse</li><li>Strategiepapiere </li><li>Verträge jeglicher Art </li><li>SOPs </li><li>SLAs </li><li>Dienstanweisungen </li><li>Personalratsvorlagen</li><li>nützliche Links </li><li>sinnvolles aus Ministerien, BMG </li><li>Gesetzesvorlagen,  Verordnungen </li><li>Fragebögen </li><li>Excel-Sheets </li><li>Präsentationen und Vorträge </li><li>Outplacement-Verträge</li><li>geschickte Trennungsrechnungs-Konzepte  Skripte</li><li>Hilfen Ihrer Mannschaft  an andere, die Sie als Dienstleistung  anbieten können.</li></ul>",
    title: "Was Sie einstellen können?",
    key: "0",
  },
  {
    content: "Ein Weiterverkauf innerhalb der meisten Förderprogramme ist unproblematisch, da er den Förderzweck nicht entfremdet. Ein Weiterverkauf verstößt somit <u>nicht</u> gegen die Bedingungen des Förderbescheids. Eine Mehrwerterschaffung sollte jedoch von der jeweiligen  Klinik an das zuständige Ministerium gemeldet werden.<br /><br />Das Anbieten ist unkritisch, sofern vom ursprünglichen Förderbescheid kein Geld entwendet oder veräußert wird und nicht gegen die Begutachtungslinie der DFG gehandelt wird. In diesem Zusammenhang darf nur Eigenleistung verkauft werden.",
    title: "Gibt es Probleme, wenn das Produkt mit der Hilfe von Förderbescheiden entwickelt wurde?",
    key: "1",
  },
  {
    content: "Einnahmen gehen, falls Sie nicht als Privatperson verkaufen, oft nicht an Sie, sondern an die Institution, in deren Namen Sie verkaufen. Solche Einnahmen können Sie Sich im Rahmen des Controllings als eigene Einnahmen durch Verrechnung gutschreiben lassen. ",
    title: "Was habe ich davon, wenn ich für meine Institution etwas verkaufe - das Geld gehört doch dann weder mir noch meiner Abteilung?",
    key: "2",
  },
  {
    content: "Wenn Sie als nicht-kommerzieller Nutzer ein Produkt anbieten, wird Ayacandas wesentliche Punkte für Sie übernehmen.",
    title: "Was ist mit dem Thema Haftung und Gewährleistung beim Einstellen von Produkten?",
    key: "3",
  },
];

let info =
  {
    "dienstleistung":"• Hilfen Ihres Personals an andere, die Sie als Dienstleistung anbieten \n• Dienstleistungen von Anbietern\n• Strategie-Beraterinnen und -Berater als Anbieter-Börse ohne Provision (Eigenvermittlung)\n• Fachberaterinnen und -berater als Anbieter-Börse ohne Provision\n• Fachberatung in sehr speziellen Gebieten (diese werden hier im Marktplatz sichtbar und suchbar)",
    "dokument":"• Dienstanweisungen\n• Datenschutz-Regelungen und -Umsetzungspapiere\n• Vorstands-Vorlagen\n• Erfolgreiche oder erfolglose Anträge (z.B. Großgeräte-Anträge)\n• Strategie-Papiere\n• Verträge jeglicher Art\n• SOPs\n• SLAs\n• Personalratsvorlagen\n• Nützliche Links\n• Gesetzesvorlagen, Verordnungen\n• Fragebögen\n• Präsentationen und Vorträge\n• Geschickte Trennungsrechnungs-Konzepte\n• Skripte\n• Im System vorher nicht vorhandene Auswertungen, die Sie oder die für Sie geschrieben wurden\n• Sinnvolles aus Ministerien (z.B. Landesministerien, BMG)\n• Outplacement-Veträge",
    "software":"• Software - Module im Bereich Ihres KIS\n• Im Klinikum erstellte Masken oder Maskenfolgen für klinische Spezialbereiche\n• Sinnvolle und nützliche Skripte oder Automatisierungen jeglicher Art\n• Excel-Sheets, die sich bei Ihnen bewährt haben\n• Word- oder Excel-Vorlagen, die für besondere Einsatzzwecke auch für andere nützlich sein können\n• Window-Administrative Skripte für den Kliniksbereich, die man sonst nicht finden kann\n• Software im Bereich von Kliniken, die man nicht als OpenSource freigeben möchte oder darf, die man  jedoch mit geringem Aufwand kostenpflichtig verkaufen möchte.",
    "softwareFUndL":"• Erweiterung Ihres KIS mit Funktionen, die Sie speziell für Forschungsbereiche implementiert haben\n• Software, die Sie für Studien geschrieben oder verändert haben\n• Software, die Sie für das Erhöhen von Studienteilnehmer-Zahlen eingebaut haben\n• Software für das Verwalten von Studierenden-Anforderungen",
    "gebrauchtSoftware":"• Ungenutzte Lizenzen - zum Beispiel nach einem Anbieterwechsel (Sprachdiktat-Software)\n• Microsoft Lizenzen, z.B. nach einer Umstellung des Lizenzmodells\n• Sprachdiktat-Lizensen nach einem Anbieter-Wechsel\n• Datenbank-Lizenzen nach einem Architektur-Wechsel",
    "sonstiges":"• Gebrauchte Server nach einem Architektur-Wechsel\n• Gebrauchte Altserver, die noch für reduzierte Zwecke verwendbar sind\n• ältere, aber noch nutzbare PCs\n• Thin Client-Endgeräte nach einem Anbieterwechsel",
  };

export class ProductList extends Component {

  

  render() {

    if (util.isGuestUser()) {
      return (
        <div className="Landing">
          <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
          <div className="ContentWithBackground">
            <div className="content" id="content">

              <div className="contentHeaderText">
                Für nicht eingeloggte Nutzer ist die Seite nicht sichtbar.
           </div>
            </div>
          </div>


          {/*  <InfoBar faq={faqProductList} />*/}
        </div>
      )
    } else {
      return (
      <div className="Landing">
        <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
        <div className="ContentWithBackground">
          <div className="content" id="content">
            <div className="contentHeaderText">
              Willkommen auf Ihrer Produkt-Seite. Hier
              können Sie Dokumente, Dienstleistungen und
              vieles mehr anbieten.
            </div>
            <div className="ProductListTiles">
              
                <div className="productListTileDownOneTile center pointer"
                     title={info.dienstleistung} onClick={(event) => this.props.history.push("/create-service")}>
                  <div className="landingOneTileContent">
                    <img src={service} alt="Dienstleistung" /><br/>
                    <div className="landingHeaderText">Dienstleistung</div>
                  </div>
                </div>
                <div className="productListTileDownOneTile center pointer"
                     title={info.dokument} onClick={(event) => this.props.history.push("/create-document")}>
                  <div className="landingOneTileContent">
                    <img src={doc} alt="Dokumente" /><br/>
                    <div className="landingHeaderText">Dokumente</div>
                  </div>
                </div>
          
             
                <div className="productListTileDownOneTile center pointer"
                     title={info.software} onClick={(event) => this.props.history.push("/create-software")}>
                  <div className="landingOneTileContent">
                    <img src={software} alt="Software" /><br/>
                    <div className="landingHeaderText">Software</div>
                  </div>
                </div>
               
                {!util.isCommercialUser() &&
                <div className="productListTileDownOneTile center  pointer"
                     title={info.softwareFUndL} onClick={(event) => this.props.history.push("/create-researchsoftware")}>
                  <div className="landingOneTileContent">
                    <img src={softwareforschung} alt="Software Forschung & Lehre" /><br/>
                    <div className="landingHeaderText">Software Forschung & Lehre</div>
                  </div>
                </div>
                }
              
                {!util.isCommercialUser() &&
                <div className="productListTileDownOneTile center pointer"
                     title={info.gebrauchtSoftware} onClick={(event) => this.props.history.push("/create-used-software")}>
                  <div className="landingOneTileContent">
                    <img src={gb} alt="Gebraucht-Software" /><br/>
                    <div className="landingHeaderText">Gebraucht-Software</div>
                  </div>
                </div>
                }
              
                <div className="productListTileDownOneTile center pointer"
                     title={info.sonstiges} onClick={(event) => this.props.history.push("/create-other")}>
                  <div className="landingOneTileContent">
                    <img src={hardware} alt="sonstige Angebote" /><br/>
                    <div className="landingHeaderText">Hardware und sonstige Angebote</div>
                  </div>
                </div>
             
                {!util.isNonCommercialUser() &&
                <div className="productListTileDownOneTile center pointer"
                     onClick={(event) => this.props.history.push("/create-tender")}>
                  <div className="landingOneTileContent">
                    <img src={tender} alt="Ausschreibung" /><br/>
                    <div className="landingHeaderText">Ausschreibung</div>
                  </div>
                </div>
                }
 
              </div>
            {/* todo make a list   */}
            <div className="productListTileDown Bold">
              <div className="ProductListTabel">
                <div className="contentHeaderText">
                  Meine bisherigen Angebote
                </div>
                <div>
                  <OldProductList history={this.props.history} />
                </div>
              </div>
            </div>
            {/*
                <div className="productListTileDown Bold marginTop50">
                <div>
                <div className="contentHeaderText">
                Meine bisherigen Käufe
                </div>
                <div>
                Todo: A product list for Products
                </div>
                </div>
                </div>
              */ }
                <div className="productListTileDown Bold marginTop50">
                  <div className="ProductListTabel">
                    <div className="contentHeaderText">
                      <Bookmark history={this.props.history} />
                    </div>
                  </div>
                </div>
          </div>
        </div>
       <Footer faqs={faqProductList} />
      </div>
    );
  }
}
}

class OldProductList extends Component {
  constructor(props) {
    super(props);
    this.getUsersProducts = this.getUsersProducts.bind(this);
    this.onDeleteProduct = this.onDeleteProduct.bind(this);
    this.onViewDetails = this.onViewDetails.bind(this);
    this.onViewDocumentDetails = this.onViewDocumentDetails.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.onUpdateDocument = this.onUpdateDocument.bind(this);
    this.onDeleteDocument = this.onDeleteDocument.bind(this);
    this.onDeleteResearchsoftware = this.onDeleteResearchsoftware.bind(this);
    this.onUpdateResearchsoftware = this.onUpdateResearchsoftware.bind(this);
    this.onViewResearchsoftwareDetails = this.onViewResearchsoftwareDetails.bind(this);
    this.onUpdateNewService = this.onUpdateNewService.bind(this);
    this.onUpdateTender = this.onUpdateTender.bind(this);
    this.onDeleteTender = this.onDeleteTender.bind(this);
    this.onViewTenderDetails = this.onViewTenderDetails.bind(this);
    this.onDeleteNewService = this.onDeleteNewService.bind(this);
    this.onViewNewServiceDetails = this.onViewNewServiceDetails.bind(this);
    this.onUpdateNewSoftware = this.onUpdateNewSoftware.bind(this);
    this.onDeleteNewSoftware = this.onDeleteNewSoftware.bind(this);
    this.onViewNewSoftwareDetails = this.onViewNewSoftwareDetails.bind(this);
    this.onDeleteUsedSoftware = this.onDeleteUsedSoftware.bind(this);
    this.onUpdateUsedSoftware = this.onUpdateUsedSoftware.bind(this);
    this.onViewUsedSoftwareDetails = this.onViewUsedSoftwareDetails.bind(this);

    this.onDeleteOther = this.onDeleteOther.bind(this);
    this.onUpdateOther = this.onUpdateOther.bind(this);
    this.onViewOtherDetails = this.onViewOtherDetails.bind(this);

    this.state = { products: [] };
    this.getUsersProducts();
  }

  getUsersProducts() {
    const self = this;
    const url = '/api/products-by-user';
    const headers = defaultHeaders();
    headers.append("Accept", "application/json");
    var promise = fetch(url, {
      method: 'GET',
      headers: headers
    }).then(response => response.ok ? response.json() : null)
      .catch(function (exception) {
        console.error('Could not load users products.', exception);
      });

    promise.then(function (json) {
      if(json === null) {
        self.setState({products: []});
        return;
      }

      var products = (JSON.parse(json[3][1])).map((obj, i) =>
        <ProductsRow name={obj.name} description={obj.description} published={obj.published}
                     type={obj.type} key={obj.id} id={obj.id} order={i} owner={obj.owner}
                     onUpdate={self.onUpdate} onDeleteProduct={self.onDeleteProduct} onViewDetails={self.onViewDetails} />
      );
      var lengthSoFar = products.length;

      var documents = json[4][1];
      for (let i = 0; i < documents.length; i++) {
        let doc = documents[i];
        products.push(
          <ProductsRow name={doc.name} type="Dokument" key={'document' + doc.id} id={doc.id} published={doc.published}
                       onUpdate={self.onUpdateDocument} owner={true} onDeleteProduct={self.onDeleteDocument}
                       order={lengthSoFar + i}
                       onViewDetails={self.onViewDocumentDetails} />
        );
      }
      lengthSoFar = lengthSoFar + documents.length;

      var researchsoftwares = json[5][1];
      for (let i = 0; i < researchsoftwares.length; i++) {
        let ressoft = researchsoftwares[i];
        products.push(
          <ProductsRow name={ressoft.name} type="Software F+L" key={'reseachsoftware' + ressoft.id} id={ressoft.id} published={ressoft.published}
                       onUpdate={self.onUpdateResearchsoftware} owner={true} onDeleteProduct={self.onDeleteResearchsoftware}
                       order={lengthSoFar + i}
                       onViewDetails={self.onViewResearchsoftwareDetails} />
        );
      }
      lengthSoFar = lengthSoFar + researchsoftwares.length;

      var serviceList = json[6][1];
      for (let i = 0; i < serviceList.length; i++) {
        let service = serviceList[i];
        products.push(
          <ProductsRow name={service.name} type="Dienstleistung" key={'service' + service.id} id={service.id} published={service.published}
                       onUpdate={self.onUpdateNewService} owner={true} onDeleteProduct={self.onDeleteNewService}
                       order={lengthSoFar + i}
                       onViewDetails={self.onViewNewServiceDetails} />
        );
      }
      lengthSoFar = lengthSoFar + serviceList.length;

      var tenderList = json[7][1];
      for (let i = 0; i < tenderList.length; i++) {
        let tender = tenderList[i];
        products.push(
          <ProductsRow name={tender.name} type="Ausschreibung" key={'tender' + tender.id} id={tender.id} published={tender.published}
                       onUpdate={self.onUpdateTender} owner={true} onDeleteProduct={self.onDeleteTender}
                       order={lengthSoFar + i}
                       onViewDetails={self.onViewTenderDetails} />
        );
      }
      lengthSoFar = lengthSoFar + tenderList.length;

      var softwareList = json[8][1];
      for (let i = 0; i < softwareList.length; i++) {
        let software = softwareList[i];
        products.push(
          <ProductsRow name={software.name} type="Software" key={'software' + software.id} id={software.id} published={software.published}
                       onUpdate={self.onUpdateNewSoftware} owner={true} onDeleteProduct={self.onDeleteNewSoftware}
                       order={lengthSoFar + i}
                       onViewDetails={self.onViewNewSoftwareDetails} />
        );
      }
      lengthSoFar = lengthSoFar + softwareList.length;

      var usedsoftwareList = json[9][1];
      for (let i = 0; i < usedsoftwareList.length; i++) {
        let usedsoft = usedsoftwareList[i];
        products.push(
          <ProductsRow name={usedsoft.name} type="Gebrauchtsoftware" key={'usedsoftware'+usedsoft.id} id={usedsoft.id} published={usedsoft.published}
                       onUpdate={self.onUpdateUsedSoftware} owner={true} onDeleteProduct={self.onDeleteUsedSoftware}
                       order={lengthSoFar + i}
                       onViewDetails={self.onViewUsedSoftwareDetails} />
        );
      }

      lengthSoFar = lengthSoFar + usedsoftwareList.length;

      var otherList = json[10][1];
      for (let i = 0; i < otherList.length; i++) {
        let other = otherList[i];
        products.push(
          <ProductsRow name={other.name} type="Hardware und sonstige Angebote" key={'other'+other.id} id={other.id} published={other.published}
                       onUpdate={self.onUpdateOther} owner={true} onDeleteProduct={self.onDeleteOther}
                       order={lengthSoFar + i}
                       onViewDetails={self.onViewOtherDetails} />
        );
      }
      lengthSoFar = lengthSoFar + otherList.length;

      self.setState({ products })
    });
  }

  onDeleteProduct(productID) {
    if (window.confirm('Möchten Sie Ihr Produkt wirklich löschen?')) {
      const self = this;
      const url = '/api/delete-product';
      const headers = defaultHeaders();
      headers.append("Accept", "application/json");
      headers.append('Content-Type', 'application/x-www-form-urlencoded');
      var promise = fetch(url, {
        method: 'POST',
        headers: headers,
        body: `id=${productID}`
      }).then(response => response.json())
        .catch(function (exception) {
          console.error('Could not delete product.', exception);
        });

      promise.then(function (json) {
        self.getUsersProducts();
      });
      return;
    }
  }

  onViewDetails(productID) {
    this.props.history.push(`/product-details/${productID}`);
    return;
  }

  onViewDocumentDetails(productID) {
    this.props.history.push(`/document-details/${productID}`);
    return;
  }

  onViewResearchsoftwareDetails(productID) {
    this.props.history.push(`/researchsoftware-details/${productID}`);
    return;
  }

  onViewNewServiceDetails(productID) {
    this.props.history.push(`/show-service/${productID}`);
    return;
  }

  onViewTenderDetails(productID) {
    this.props.history.push(`/show-tender/${productID}`);
  }

  onViewNewSoftwareDetails(productID) {
    this.props.history.push(`/show-software/${productID}`);
    return;
  }

  onViewUsedSoftwareDetails(productID) {
    this.props.history.push(`/show-used-software/${productID}`);
    return;
  }

  onViewOtherDetails(productID) {
    this.props.history.push(`/show-other/${productID}`);
    return;
  }

  onUpdate(productID, productType) {
    const url = productType === 'Software' ? 'software' : 'services';
    this.props.history.push(`/${url}/${productID}/edit`);
    return;
  }

  onUpdateDocument(id) {
    this.props.history.push(`/update-document/${id}`);
  }

  onUpdateResearchsoftware(id) {
    this.props.history.push(`/update-researchsoftware/${id}`);
  }

  onUpdateNewService(id) {
    this.props.history.push(`/update-service/${id}`);
  }

  onUpdateTender(id) {
    this.props.history.push(`/update-tender/${id}`);
  }

  onUpdateNewSoftware(id) {
    this.props.history.push(`/update-software/${id}`);
  }

  onUpdateUsedSoftware(id) {
    this.props.history.push(`/update-used-software/${id}`);
  }

  onUpdateOther(id) {
    this.props.history.push(`/update-other/${id}`);
  }

  onDeleteDocument(id) {
    if (window.confirm("Möchte Sie ihr Produkt wirklich löschen?")) {
      const url = `/api/delete-document`
      const headers = defaultHeaders();
      headers.append("Accept", "application/json");
      headers.append('Content-Type', 'application/x-www-form-urlencoded');
      fetch(url, {
        method: 'POST',
        headers: headers,
        body: `id=${id}`,
      })
        .then(resp => resp.json())
        .then(json => this.getUsersProducts());
    }
  }

  onDeleteResearchsoftware(id) {
    if (window.confirm("Möchte Sie ihr Produkt wirklich löschen?")) {
      const url = `/api/delete-researchsoftware`
      const headers = defaultHeaders();
      headers.append("Accept", "application/json");
      headers.append('Content-Type', 'application/x-www-form-urlencoded');
      fetch(url, {
        method: 'POST',
        headers: headers,
        body: `id=${id}`,
      })
        .then(resp => resp.json())
        .then(json => this.getUsersProducts());
    }
  }

  onDeleteNewService(id) {
    if (window.confirm("Möchte Sie ihr Produkt wirklich löschen?")) {
      const url = `/api/new-delete-service`
      const headers = defaultHeaders();
      headers.append("Accept", "application/json");
      headers.append('Content-Type', 'application/x-www-form-urlencoded');
      fetch(url, {
        method: 'POST',
        headers: headers,
        body: `id=${id}`,
      })
        .then(resp => resp.json())
        .then(json => this.getUsersProducts());
    }
  }

  onDeleteTender(id) {
    if (window.confirm("Möchte Sie ihr Produkt wirklich löschen?")) {
      const url = `/api/delete-tender`
      const headers = defaultHeaders();
      headers.append("Accept", "application/json");
      headers.append('Content-Type', 'application/x-www-form-urlencoded');
      fetch(url, {
        method: 'POST',
        headers: headers,
        body: `id=${id}`,
      })
        .then(resp => resp.json())
        .then(json => this.getUsersProducts());
    }
  }

  onDeleteNewSoftware(id) {
    if (window.confirm("Möchte Sie ihr Produkt wirklich löschen?")) {
      const url = `/api/new-delete-software`
      const headers = defaultHeaders();
      headers.append("Accept", "application/json");
      headers.append('Content-Type', 'application/x-www-form-urlencoded');
      fetch(url, {
        method: 'POST',
        headers: headers,
        body: `id=${id}`,
      })
        .then(resp => resp.json())
        .then(json => this.getUsersProducts());
    }
  }

  onDeleteUsedSoftware(id) {
    if (window.confirm("Möchte Sie ihr Produkt wirklich löschen?")) {
      const url = `/api/delete-used-software`
      const headers = defaultHeaders();
      headers.append("Accept", "application/json");
      headers.append('Content-Type', 'application/x-www-form-urlencoded');
      fetch(url, {
        method: 'POST',
        headers: headers,
        body: `id=${id}`,
      })
        .then(resp => resp.json())
        .then(json => this.getUsersProducts());
    }
  }

  onDeleteOther(id) {
    if (window.confirm("Möchte Sie ihr Produkt wirklich löschen?")) {
      const url = `/api/delete-other-product`
      const headers = defaultHeaders();
      headers.append("Accept", "application/json");
      headers.append('Content-Type', 'application/x-www-form-urlencoded');
      fetch(url, {
        method: 'POST',
        headers: headers,
        body: `id=${id}`,
      })
        .then(resp => resp.json())
        .then(json => this.getUsersProducts());
    }
  }

  render() {
    return (
      <div className="ProductList">
        <ProductsList products={this.state.products} history={this.props.history} />
      </div>
    )
  }
}

class ProductsList extends Component {
  render() {
    return (
      <div className="ProductsList">
        <ProductsHeader />
        {this.props.products}
      </div>
    )
  }
}

class ProductsHeader extends Component {
  render() {
    return (
      <div className="ProductsHeader">
        <HeaderText text="Name" />
        <HeaderText text="veröffentlicht" />
        <HeaderText text="Typ" />
        <HeaderButton />
        <HeaderButton />
        <HeaderButton />
      </div>
    )
  }
}

class ProductsRow extends Component {
  render() {
    return (
      <div className="ProductsRow"  title={this.props.description} >
        <RowTextName text={this.props.name} />
        <RowText text={this.props.published === true ? 'ja' : 'nein'} />
        <RowText text={this.props.type} />
        <RowButton text="Ansicht" id={this.props.id} job="viewDetails" onViewDetails={this.props.onViewDetails} />
        <RowButton text="ändern" disabled={this.props.owner !== true} id={this.props.id} job="update" onUpdate={this.props.onUpdate} type={this.props.type} />
        <RowButton text="löschen" disabled={this.props.owner !== true} id={this.props.id} job="delete" onDeleteProduct={this.props.onDeleteProduct} />
      </div>
    )
  }
}

class HeaderText extends Component {
  render() {
    return (
      <div className="HeaderText openSans">
        <b>{this.props.text}</b>
      </div>
    )
  }
}

class RowText extends Component {
  render() {
    return (
      <div className="RowText openSans ProductListBorder">
        {this.props.text}
      </div>
    )
  }
}

/* Add row TextBlue just to have blue for names in table.*/

class RowTextName extends Component {
  render() {
    return (
      <div className="RowText RowTextBlue openSans ProductListBorder">
        {this.props.text}
      </div>
    )
  }
}

class HeaderButton extends Component {
  render() {
    return (
      <div className="HeaderButton">
      </div>
    )
  }
}

class RowButton extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    switch (this.props.job) {
      case 'viewDetails':
        this.props.onViewDetails(this.props.id);
        break;
      case 'delete':
        this.props.onDeleteProduct(this.props.id);
        break;
      case 'update':
        this.props.onUpdate(this.props.id, this.props.type);
        break;
      default:
        console.error("RowButton: Slipped unexpectedlty through switch-case.");
    }
  }

  render() {
    return (
      <div className={this.props.disabled === true ? "button disabled margin2" :"BookmarkRowButton"}
           onClick={this.onClick} >
        {this.props.text}
      </div>
    )
  }
}

// Old and some new Bookmark code follows


class BookmarkHeaderButton extends Component {
  render() {
    return (
      <div className="BookmarkHeaderButton">
      </div>
    )
  }
}

class BookmarkRowText extends Component {
  render() {
    return (
      <div className="RowText openSans ProductListBorder">
        {this.props.text}
      </div>
    )
  }
}

// Add this new component identical to BookmarkRowText just to
// have the names in blue color.
class BookmarkRowTextName extends Component {
  render() {
    return (
      <div className="RowText RowTextBlue openSans ProductListBorder">
        {this.props.text}
      </div>
    )
  }
}

class BookmarkHeaderText extends Component {
  render() {
    return (
      <div className="HeaderText openSans">
        <b>{this.props.text}</b>
      </div>
    )
  }
}

class BookmarksHeader extends Component {
  render() {
    return (
      <div className="ProductsHeader">
        <BookmarkHeaderText text="Name" />
        <BookmarkHeaderText text="Typ" />
        <BookmarkHeaderButton />
        <BookmarkHeaderButton />
      </div>
    )
  }
}

class BookmarkRowButton extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    switch (this.props.job) {
      case 'viewDetails':
        this.props.onViewDetails(this.props.type, this.props.id);
        break;
      case 'remove':
        this.props.onRemoveBookmark(this.props.id,this.props.type);
        break;
      default:
        console.error("RowButton: Slipped unexpectedlty through switch-case.");
    }
  }

  render() {
    return (
      <div className={this.props.disabled === true ? "RowButton disabled" : "BookmarkRowButton"}
           onClick={this.onClick} >
        {this.props.text}
      </div>
    )
  }
}

class BookmarkProductsRow extends Component {
  constructor(props) {
    super(props);
    this.translateTypeIntoGerman = this.translateTypeIntoGerman.bind(this);
  }

  translateTypeIntoGerman(type) {
    switch (type) {
      case "document":
        return 'Dokument';
      case "software":
        return 'Software';
      case "service":
        return "Dienstleistung";
      case "tender":
        return "Ausschreibung";
      case "used_software":
        return "Gebrauchtsoftware";
      case "research_software":
        return "Software F+L";
      case "service old":
        return "Dienstleistung Alt";
      case "software old":
        return "Software Alt";
      case "other":
        return "Hardware und sonstige Angebote";
      default:
        return "Unbekannter Produkttyp";
    }
  }

  render() {
    return (
      <div className="ProductsRow">
        <BookmarkRowTextName text={this.props.name} />
        <BookmarkRowText text={this.translateTypeIntoGerman(this.props.type)} />
        <BookmarkRowButton text="Ansicht" id={this.props.id} type={this.props.type} job="viewDetails" onViewDetails={this.props.onViewDetails} />
        <BookmarkRowButton text="Entfernen"  id={this.props.id} type={this.props.type} job="remove"  onRemoveBookmark={this.props.onRemoveBookmark} />
      </div>
    )
  }
}

export class Bookmark extends Component {
  constructor(props) {
    super(props);
    this.onViewDetails = this.onViewDetails.bind(this);
    this.onRemoveBookmark = this.onRemoveBookmark.bind(this);
    this.getBookmarkedProducts = this.getBookmarkedProducts.bind(this);
    this.state = {
      bookmarkList: []
    };
  }

  componentWillMount() {
    this.getBookmarkedProducts();
  }

  onViewDetails(type, id) {
    switch (type) {
      case "document":
        this.props.history.push(`/document-details/${id}`);
        return;
      case "software":
        this.props.history.push(`/show-software/${id}`);
        return;
      case "service":
        this.props.history.push(`/show-service/${id}`);
        return;
      case "tender":
        this.props.history.push(`/show-tender/${id}`);
        return;
      case "used_software":
        this.props.history.push(`/show-used-software/${id}`);
        return;
      case "research_software":
        this.props.history.push(`/researchsoftware-details/${id}`);
        return;
      case "other":
        this.props.history.push(`/show-other/${id}`);
        return;
      default:
        this.props.history.push(`/product-details/${id}`);
        return;
    }
  }

  onRemoveBookmark(productID, productType) {
    if (window.confirm('Möchten Sie das Produkt aus der Bookmarkliste entfernen?')) {
      const self = this;
      const url = '/api/remove-bookmark';
      const headers = defaultHeaders();
      headers.append("Accept", "application/json");
      headers.append('Content-Type', 'application/x-www-form-urlencoded');
      var promise = fetch(url, {
        method: 'POST',
        headers: headers,
        body: `id=${productID}&type=${productType}`
      }).then(response => response.json())
        .catch(function (exception) {
          console.error('Could not delete product.', exception);
        });
      promise.then(function (json) {
        self.getBookmarkedProducts();
      });
      return;
    }
  }

  getBookmarkedProducts() {
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    var url = `/api/get-bookmarks`;
    var promise = fetch(url, {
      method: 'GET',
      headers: headers
    })
      .then(response => response.ok ? response.json() : null)
      .catch(function(exception) {
        console.error(`Could not retrieve bookmarked products!`, exception);
      });
    promise.then(function(json) {
      self.setState({
        bookmarkList: json || []
      });
    })
  }

  render() {
    let items = this.state.bookmarkList.map((item, i) =>
      <BookmarkProductsRow name={item.name} type={item.type} id={item.id} order={i} onViewDetails={this.onViewDetails} onRemoveBookmark={this.onRemoveBookmark}/>
    );

    return (
      <div className="ProductListTabel">
        <div className="contentHeaderText">Bookmarks</div>
        <div className="ProductsList">
          <BookmarksHeader />
          {items}
        </div>
      </div>
    )
  }
}
// Old Bookmarks code ends



// WEBPACK FOOTER //
// ./src/product-list.js